module.exports = __webpack_public_path__ + "static/media/swap-space.feaf67f1.svg";